import { useRef, useState } from 'react';

export const useParallax = () => {
    const cardRef = useRef<HTMLDivElement>(null);
    const [tilt, setTilt] = useState({ x: 0, y: 0 });
    const [shine, setShine] = useState({ x: 50, y: 50 });

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!cardRef.current) return;

        const card = cardRef.current;
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        const rotateX = ((y - centerY) / centerY) * -12;
        const rotateY = ((x - centerX) / centerX) * 12;

        setTilt({ x: rotateX, y: rotateY });
        setShine({ 
            x: (x / rect.width) * 100, 
            y: (y / rect.height) * 100 
        });
    };

    const handleMouseLeave = () => {
        setTilt({ x: 0, y: 0 });
        setShine({ x: 50, y: 50 });
    };

    const getParallaxStyle = () => ({
        transform: `perspective(1000px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
        transition: tilt.x === 0 && tilt.y === 0 ? 'transform 0.5s ease-out' : 'none',
        ['--shine-x' as any]: `${shine.x}%`,
        ['--shine-y' as any]: `${shine.y}%`,
    });

    return {
        cardRef,
        handleMouseMove,
        handleMouseLeave,
        getParallaxStyle,
    };
};
